import React from 'react';
import Hero from '../components/landing/Hero';
import PresaleBanner from '../components/landing/PresaleBanner';
import Solutions from '../components/landing/GettingStarted';
import AboutSection from '../components/landing/About';
import TokenDistribution from '../components/landing/TokenDistribution';
import Partners from '../components/landing/Partners';
import Disclaimer from '../components/landing/Disclaimer';
import JoinCommunity from '../components/landing/JoinCommunity';

export default function Home() {
  return (
    <>
      <Hero />
      <PresaleBanner />
      <AboutSection />
      <Solutions />
      <TokenDistribution />
      <JoinCommunity />
      <Partners />
      <Disclaimer />
    </>
  );
}
